import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values () {
    return {
      strings: Array
    }
  }

  // typed.js is loaded on connect so it stays out of the bundle every page downloads.
  async connect () {
    const connection = (this.connection = Symbol("connection"))
    const { default: Typed } = await import("typed.js")
    if (this.connection !== connection) return // disconnected (or reconnected) while loading

    this.typed = new Typed(this.element, {
      strings: this.stringsValue,
      typeSpeed: 20,
      backDelay: 2000,
      loop: true
    })
  }

  disconnect () {
    this.connection = null
    if (this.typed) {
      this.typed.destroy()
      this.typed = null
    }
  }
}
